
import { getDynamicConfigValue } from '../dynamicConfig';

var keymakerApiKey = null;
const defaultKeymakerApiKey = getDynamicConfigValue('REACT_APP_KEYMAKER_API_KEY');

export const setKeymakerApiKey = (key) => keymakerApiKey = key;
export const getKeymakerApiKey = () => (keymakerApiKey) ? keymakerApiKey : defaultKeymakerApiKey;

